import Header from "views/Header"
import Content from "views/Content"
import Footer from "views/Footer"
import Toast from "components/Toast";
import { useLocation } from "react-router-dom"
import { newsCategoriesActions } from "redux/slice/newsCategoriesSlice"
import { tourTypeActions } from "redux/slice/tourTypeSlice"
import { useDispatch } from "react-redux";
import { useEffect } from "react";

function App() {
  const path = useLocation().pathname
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(newsCategoriesActions.getNewsCategoriesAll())
    dispatch(tourTypeActions.getTourTypeAll())
  }, [dispatch])

  return (
    <div className="App">
      <Toast>
        {
          !path.includes("admin") &&
          <Header />
        }
        <Content />
        {
          !path.includes("admin") &&
          <Footer />
        }
      </Toast>
    </div>
  );
}

export default App;
